module.exports = __webpack_public_path__ + "img/dimasi.66428743.jpg";